module.exports = __webpack_public_path__ + "media/images/flags/pk-8f9276eb2e7dc3eac94d57ec63ea2818.svg";